import {
  CHANGE_SETTLEMENTS_IS_SAVE,
  GET_RAYON_BY_OBLAST_SETTLEMENTS,
  GET_RAYON_FOR_MODAL,
  GET_SETTLEMENT,
  GET_SETTLEMENTS,
  GET_SETTLEMENTS_ERROR,
  GET_SETTLEMENTS_NO_ERROR,
  RESET_SETTLEMENT,
  SET_SEARCH_PARAMS_SETTLEMENTS,
} from "../../types";

const initialState = {
  settlements: [],
  settlement: {},
  searchParams: {
    oblast: 0,
    rayon: 0,
    nameRu: "",
  },
  rayon: [],
  rayonModal: [],
  error: "",
  isSave: false,
};

export const settlementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTLEMENTS:
      return (() => ({
        ...state,
        settlements: action.data,
      }))();
    case SET_SEARCH_PARAMS_SETTLEMENTS:
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    case GET_RAYON_BY_OBLAST_SETTLEMENTS:
      return {
        ...state,
        rayon: action.data,
      };
    case GET_SETTLEMENT:
      return {
        ...state,
        settlement: action.data,
      };
    case RESET_SETTLEMENT:
      return {
        ...state,
        settlement: {},
      };
    case GET_RAYON_FOR_MODAL:
      return {
        ...state,
        rayonModal: action.data,
      };
    case GET_SETTLEMENTS_ERROR:
      return (() => ({
        ...state,
        error: action.data,
        isSave: false,
      }))();
    case GET_SETTLEMENTS_NO_ERROR:
      return (() => ({
        ...state,
        error: action.data,
        isSave: true,
      }))();
    case CHANGE_SETTLEMENTS_IS_SAVE:
      return (() => ({
        ...state,
        isSave: false,
      }))();
    default:
      return state;
  }
};
